import   React    from "react";

import   classNames  from "classnames";

import   styles       from "./TierPickerModal.module.scss";

import   Trigger      from "../../widget/actuators/Trigger";
import   Box           from "../../widget/windows/Box";

import { useTypedSelector    }  from "../../../store/useTypeSelector";
import { resolveTierPick     }  from "../../../utils/utils_tierPicker";

// tier.priceWithTax vient de Product.variants[].prices[].priceWithTax (api_product.ts,
// mapPrice) — DÉJÀ converti de centimes en euros à la lecture du catalogue. Le rediviser
// par 100 ici affichait 0,05 € au lieu de 5,00 € (bug réel, vu en achetant un device).
const RECURRING_UNIT_SUFFIX: Record<string, string> = {
  day:   "/jour",
  week:  "/semaine",
  month: "/mois",
  year:  "/an",
};

const formatPrice = (tier: { priceWithTax: number; isRecurring: boolean; recurringIntervalUnit: string | null }): string => {
  const suffix = tier.isRecurring ? (RECURRING_UNIT_SUFFIX[tier.recurringIntervalUnit ?? ''] ?? "/récurrent") : "";
  return `${tier.priceWithTax.toFixed(2)} €${suffix}`;
};

// Monté une seule fois, à la racine de l'app (index.tsx), comme QuotaPurchaseModal :
// s'affiche dès qu'un openBuyXxx() (utils_*Purchase.ts) trouve plusieurs paliers actifs
// pour la ressource demandée et appelle pickTier() (utils_tierPicker.ts).
export const TierPickerModal: React.FC = () => {

  const { open, label, tiers } = useTypedSelector((state) => state.tierPickerReducer);

  if (!open) {
    return null;
  }

  return (
    // marginTop : Box vaut 130px par défaut (pensé pour une fenêtre avec logo) — sans
    // cette réduction, un grand vide sépare le titre de la liste des paliers.
    <Box onClose={() => resolveTierPick(null)} width="380px" marginTop="16px">
      <div className={classNames(styles.root)}>

        <div className={classNames(styles.title)}>
          {label}
        </div>

        <div className={classNames(styles.tierList)}>
          {tiers.map((tier) => (
            <Trigger
              key={tier.variantCode}
              name={`${tier.isRecurring ? "Abonnement — " : ""}${tier.name} — ${formatPrice(tier)}`}
              onClick={() => resolveTierPick(tier)}
            />
          ))}
        </div>

        <div className={classNames(styles.cancel)}>
          <Trigger name="Annuler" onClick={() => resolveTierPick(null)} />
        </div>

      </div>
    </Box>
  );
};

export default TierPickerModal;
